<template>
  <div class="message2" :class="{ 'from-user': owner }">
    <img @click="setVote(1)" style="height: 25px" src="../assets/up.png"> {{message.votes}} <img @click="setVote(0)" style="height: 25px" src="../assets/down.png"> {{ message.text }}
    <br />

    <audio v-if="message.audioURL" :src="message.audioURL" controls></audio>
    <br />

    <span class="sender">made by <router-link :to="{ name: 'profile', params: { uid: message.sender } }">{{ displayName.userName }}</router-link> on page {{message.page}}</span>
  </div>
</template>

<script>
import { db } from '../firebase';
import swal from 'sweetalert';

export default {
    data() {
      return { 
            displayName: '',
            voteReg: null 
      }
    },
    firestore() {
      return {
        displayName: this.userName,
        voteReg: this.voteVerify.doc(`${this.message.messageId}`)
      };
    },
    props: ['message', 'owner', 'prevRef', 'prevRef1', 'yourId'],
    computed: {
      chatId() {
        return this.$route.params.id;
      },
      userName(){
        return db.doc(`users/${this.message.sender}`)
      },
      votes() {
        return db.doc(`chats/${this.chatId}/messages/${this.prevRef}/messages/${this.prevRef1}/messages/${this.message.messageId}`)
      },
      voteVerify(){
        return db.doc(`users/${this.yourId}/votes/${this.chatId}`).collection('comments');
      }
    },
    methods: {
      async setVote(arrow){
        let ref = this.message.messageId;

        if(this.message.sender !== this.yourId){
          if(arrow === 1){
            if(this.voteReg === null){
              await this.voteVerify.doc(ref).set({
                vote: 2,
                createdAt: Date.now()
              });
              let n = this.message.votes + 1;
              await this.votes.update({
                votes: n
              });
            }
            else if(this.voteReg.vote === 1){
              await this.voteVerify.doc(ref).set({
                vote: 2,
                createdAt: Date.now()
              });
              let n = this.message.votes + 1;
              await this.votes.update({
                votes: n
              });
            }
            else if(this.voteReg.vote === 0){
              await this.voteVerify.doc(ref).set({
                vote: 1,
                createdAt: Date.now()
              });
              let n = this.message.votes + 1;
              await this.votes.update({
                votes: n
              });
            }
          }
          if(arrow === 0){
            if(this.voteReg === null){
              await this.voteVerify.doc(ref).set({
                vote: 0,
                createdAt: Date.now()
              });
              let n = this.message.votes - 1;
              await this.votes.update({
                votes: n
              });
            }
            else if(this.voteReg.vote === 1){
              await this.voteVerify.doc(ref).set({
                vote: 0,
                createdAt: Date.now()
              });
              let n = this.message.votes - 1;
              await this.votes.update({
                votes: n
              });
            }
            else if(this.voteReg.vote === 2){
              await this.voteVerify.doc(ref).set({
                vote: 1,
                createdAt: Date.now()
              });
              let n = this.message.votes - 1;
              await this.votes.update({
                votes: n
              });
            }
          }
        }
        else{
          swal("Sorry", "You can't vote on your own comment.", "warning");
        }
      }
    }

};
</script>
<style>
.message2 {
  background: #dddddd;
  color: black;
  width: 50%;
  border-radius: 5px;
  padding: 12px;
  display: inline-block;
}
.sender {
  font-size: 0.5rem;
}
</style>
